(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name crewing.controller:AddMemoCtrl
     *
     * @description
     *
     */
    angular
        .module('snap')
        .controller('RosterScoreVersionCtrl', RosterScoreVersionCtrl);

    function RosterScoreVersionCtrl($uibModalInstance, modalParams, $window, CommonMasterData, MessageService, AdminSnapService,PopupManager) {
        var vm = this;

        vm.model = {
            params: {
                scoreVersion: null,
                crewType: null,
                selectedRow: modalParams.selectedRow

            },
            crewTypes: []
        };

        (function INIT() {
            loadCrewTypes();
        })();


       /* angular.element($window).bind('keydown', function (e) {
          	 if(e.which == 46 || e.which == 110){
          		vm.onDeleteClick();
           }
          })
*/
        vm.onSaveClick = function () {
            if (vm.form.$valid) {

              var populateScore = AdminSnapService.setSnapeScoreRequest(vm.model.params);

              AdminSnapService.scoreRosterSnap(populateScore,
                function(response) {
                  if (response.success) {
                    MessageService.success('Score Snap is Successfully saved!');
                    PopupManager.closeModal('ADD_ROSTER_SCORE_VERSION');
                  } else {
                    MessageService.error(response.errors[0]);
                  }
                }, function(error) {
                  MessageService.error(error[0]);
                });

            }
        };

        function loadCrewTypes() {
          CommonMasterData.getCrewTypeList(
            function (crewTypes) {
              vm.model.crewTypes = crewTypes;
            },
            function () {
              console.log('Crew type retrieval error');
            }
          );
        }

      vm.closeMe = function() {
        PopupManager.closeModal('ADD_ROSTER_SCORE_VERSION');
      }

      CommonMasterData.getCrewTypeList(
        function (crewTypes) {
          vm.model.crewTypes = crewTypes;
        },
        function () {
          console.log('Crew type retrieval error');
        }
      );
    }
}());
